import {
  getAppid,
  getWxOpenid,
} from "@/api/user.js";

const urlencode = require('urlencode');
const Base64 = require("js-base64").Base64;

// 获取参数值
function getUrlValue(paramName) {
  var url = window.location.href; //当前页面的地址
  var reg = /([^?&=]+)=([^?&=]+)/g,
    obj = {};
  url.replace(reg, function () {
    obj[arguments[1]] = arguments[2];
  });
  for (var keyName in obj) {
    if (keyName == paramName) {
      return obj[keyName];
      // break;
    }
  }
}

// 获取微信
async function getWxUserInfo(code) {
  let noDecodeCustomerId = urlencode.decode(getUrlValue("customerId"));
  let customerId = Base64.decode(noDecodeCustomerId);
  let res = await getWxOpenid({
    code: code,
    customerId: customerId,
    officialAccountAppId: getUrlValue("appid"),
  });
  let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  userInfo["openId"] = res.data;
  sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
}

// 获取企业公众号信息appid
async function getGzhInfo() {
  let noDecodeCustomerId = urlencode.decode(getUrlValue("customerId"));
  let customerId = Base64.decode(noDecodeCustomerId);
  let res = await getAppid({
    customerId: customerId,
  });

  let userInfo = {
    customerId: noDecodeCustomerId,
    gzhQrCodeUrl: `${window.location.protocol +"//"+ window.location.host}/xb-api/xb-api/pic-url-proxy?picUrl=${res.data.qrCodeUrl}`,
    gzhName: res.data.nickName,
    gzhHeadImg: res.data.headImg,
  };
  let encodeUrl = encodeURIComponent(
    window.location.href + "&appid=" + res.data.appId
  );
  sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.data.appId}&redirect_uri=${encodeUrl}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=wx1c7c3cf6b5a8676f#wechat_redirect`;
  window.location.replace(url);
}

export default {
  auth: async () => {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo) {
      let openId = userInfo.openId;
      if(!openId) {
        let code = getUrlValue("code");
        if (code) {
          await getWxUserInfo(code);
        } else {
          await getGzhInfo();
        }
      }
    }else {
      await getGzhInfo();
    }
  },
  getUserInfo: () => {
    return JSON.parse(sessionStorage.getItem("userInfo"));
  },
  getEncodeCustomerId: () => {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return userInfo.customerId;
  },
  getDecodeCustomerId: () => {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return Base64.decode(userInfo.customerId);
  }
};


